<template>
  <div class="ticket">
    <ListTickets/>
  </div>
</template>

<script>
  // @ is an alias to /src
  import ListTickets from '@/components/ListJobs.vue'

  export default {
    name: 'Ticket',
    components: {
      ListTickets
    }
  }
</script>

<style lang="scss" scoped>
</style>
